import React from 'react';
import {CircularProgress, Dialog, DialogTitle, Grid} from "@mui/material";

interface IProps {
    afterEnter?: () => void;
}

interface IState {
}

class OAuthComponent extends React.Component<IProps, IState> {
    render() {
        return (
                <Dialog
                        open={true}
                        TransitionProps={{
                            onEnter: this.handleEnter
                        }}>
                    <DialogTitle>
                        <Grid container alignItems={"center"} justifyContent={"center"}>
                            Preparing for authorization <CircularProgress/>
                        </Grid>
                    </DialogTitle>
                </Dialog>
        );
    }

    private handleEnter = () => {
        if (this.props.afterEnter) {
            setInterval(() => {
                this.props.afterEnter?.()
            }, 1000)
        }
    }
}

export default OAuthComponent;